import { _ } from '@icc/shared/helpers';

export type AppointmentStatus = 'proposed' | 'confirmed' | 'in-progress' | 'rejected' | 'completed-pending' | 'completed';

export const AppointmentStatuses: Record<AppointmentStatus, string> = {
    proposed: _('COMPLAINT_APPOINTMENT|Nowa - oczekuje na potwierdzenie'),
    'in-progress': _('COMPLAINT_APPOINTMENT|Potwierdzona - w realizacji'),
    confirmed: _('COMPLAINT_APPOINTMENT|Potwierdzona - niezrealizowana'),
    rejected: _('COMPLAINT_APPOINTMENT|Odrzucona - po wizycie'),
    'completed-pending': _('COMPLAINT_APPOINTMENT|Zrealizowana - niezakończona'),
    completed: _('COMPLAINT_APPOINTMENT|Zrealizowana - zakończona'),
};

export const AppointmentStatusesColors: Record<AppointmentStatus, string> = {
    proposed: 'DF6420',
    confirmed: '0061A6',
    'in-progress': 'FFC000',
    rejected: 'F495BF',
    'completed-pending': 'FFF100',
    completed: '47D041',
};

export const appointmentStatuses = Object.keys(AppointmentStatuses).map((key) => ({
    value: key,
    label: AppointmentStatuses[key],
}));

export const editableAppointmentStatuses = Object.keys(AppointmentStatuses).filter(
    (key) => key === 'proposed' || key === 'confirmed' || key === 'in-progress'
).map((key) => ({ value: key, label: AppointmentStatuses[key] }));

export const openedAppointmentStatuses = Object.keys(AppointmentStatuses).filter(
    (key) => key === 'proposed' || key === 'in-progress'
).map((key) => ({ value: key, label: AppointmentStatuses[key] }));

export const closedAppointmentStatuses = Object.keys(AppointmentStatuses).filter(
    (key) => key === 'confirmed' || key === 'rejected' || key === 'completed-pending' || key === 'completed'
).map((key) => ({ value: key, label: AppointmentStatuses[key] }));
